'use strict';
var tmp = require('./mask.ejs');
var style = require('./mask.css');

var win = window;



var Mask = function () {
    this.isHide = true;
    this.init();
}
Mask.prototype.init = function () {
    this.resolveTemplate();
    this.renderer();
    this.bindDataEvent();
    this.hide();
}

Mask.prototype.resolveTemplate = function () {
     this.layout = $(tmp());
    this.layout.hide();
}

Mask.prototype.renderer = function () {
    $('body').append(this.layout);
    this.resizeHeight();
}

Mask.prototype.bindDataEvent = function () {
    var _this = this;
    var resizeTimer = null;
    this.layout.on('click', function () {
        if(_this.isHide ===true){
            _this.show();
        }else{
            _this.hide();
        }
       // _this.trigger('click');
    });

    $(win).on('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            _this.resizeHeight();
        }, 100);
    });
}

Mask.prototype.show = function () {
    if (this.isHide === true) {
        this.isHide = false;
        this.layout.show();
    }
}

Mask.prototype.hide = function () {
    if (this.isHide === false) {
        this.isHide = true;
        this.layout.hide();
    }
}


Mask.prototype.resizeHeight = function () {
    this.layout.height($(win).height());
}


module.exports = Mask;



// WEBPACK FOOTER //
// /Users/zhujian/Desktop/code/live_system/live/modules/f.component.pic.pc/app/modules/mask/index.js